/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import Modal from 'react-modal'
import './Modal.scss'
import { TimesIcon } from '@/icons'
import { useEffect, useState } from 'react'

const ObroModal = (props: any) => {
  const [isMobile, setIsMobile] = useState(false);

  // Ekran boyutunu kontrol edelim
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const customStyles = {
    overlay: {
      background: '#00000082',
      zIndex: 5000, // z-index değerini arttırıyoruz
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      maxWidth: isMobile ? '90%' : (props.width ? `${props.width}px` : '500px'),
      minWidth: isMobile ? '90%' : (props.width ? `${props.width}px` : '500px'),
      maxHeight: isMobile ? '80vh' : 'auto',
      border: '1px solid var(--grey-grey-30, #EAEEF4)',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      overflow: 'auto',
      height: props.height ? props.height : "unset",
      WebkitOverflowScrolling: 'touch' as 'auto' | 'touch',
      borderRadius: '4px',
      outline: 'none',
      padding: isMobile ? '15px' : '20px',
      zIndex: 5001, // z-index değerini arttırdık
    },
  }

  return (
      <Modal
        isOpen={props.showModal}
        contentLabel="Example Modal"
        style={customStyles}
        onRequestClose={props.handleCloseModal}
        ariaHideApp={false} // Erişilebilirlik uyarısını önlemek için
      >
        <div className="modal-header">
          <span className="modal-header-text">{props.header}</span>
          <button
            className="close-button"
            onClick={() => props.setIsOpen(false)}
          >
            <TimesIcon className={undefined}></TimesIcon>
          </button>
        </div>

        <div className={`margin-top-10 ${isMobile ? 'mobile-modal-content' : ''}`}>
          {props.children}
        </div>
      </Modal>
  )
}

export default ObroModal
